import {Component, computed, HostListener, OnInit, signal} from '@angular/core';
import {ThemeCustomizerService} from '../theme-customizer/theme-customizer.service';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NgClass, NgForOf, NgIf, NgOptimizedImage} from '@angular/common';
import {ApiService} from '../../core/services/api.service';
import {CategoriesService} from '../../core/services/category.service';
import {GenCategory} from '../../core/models/genCategory.model';
import {CartService} from '../../core/services/cart.service';
import {createLogger} from '../../shared/helpers/logger/logger';
import {CartPageComponent} from '../../pages/cart/cart-page/cart-page.component';
import {UserService} from '../../core/services/user.service';
import {LoginModalService} from "../../shared/helpers/login-modal/login-modal.service";

const logger = createLogger('HeaderStyleOneComponent');

@Component({
    standalone: true,
    selector: 'app-header-style-one',
    imports: [RouterLinkActive, NgClass, RouterLink, NgForOf, NgIf, NgOptimizedImage, CartPageComponent],
    templateUrl: './header-style-one.component.html',
    styleUrls: ['./header-style-one.component.scss']
})
export class HeaderStyleOneComponent implements OnInit {
    isSticky: boolean = false;
    shopCategories: GenCategory[] = [];
    isToggled = false;
    classApplied = false;
    classApplied2 = false;
    classApplied3 = false;
    isSideCartOpen = false;

    // Signals for user state
    currentUser = this.userService.getCurrentUserSignal();
    profileImageUrl = computed(() => this.currentUser()?.profile?.display_image || '');
    isLoggedIn = computed(() => this.userService.isLoggedIn());
    cartItemCount = computed(() => this.cartService.cartItemCount());

    // Add loading signal
    isLoading = signal(true);

    constructor(
        public themeService: ThemeCustomizerService,
        public apiService: ApiService,
        private categoriesService: CategoriesService,
        private userService: UserService,
        private cartService: CartService,
        private loginModalService: LoginModalService,
    ) {
        this.isLoading.set(true);
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        this.isSticky = scrollPosition >= 50;
    }

    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    toggleClass3() {
        this.classApplied3 = !this.classApplied3;
    }

    toggleSideCart() {
        this.isSideCartOpen = !this.isSideCartOpen;
    }

    async openLoginModal() {
        this.loginModalService.show('');
    }

    async ngOnInit(): Promise<void> {
        // Fetch shop categories
        const params: any = {filter: {type: 'ecommerce', lvl: 0}};
        try {
            const response = await this.categoriesService.getCategories(params);
            this.shopCategories = response.data;
        } catch (error) {
            logger.error('Error fetching categories:', error);
        }

        // Initialize user state and manage loading
        try {
            await this.userService.initializeUser(); // Ensure this sets currentUser signal
        } catch (error) {
            logger.error('Error initializing user:', error);
        } finally {
            this.isLoading.set(false); // Set to false only after user state is resolved
        }
    }

    closeMenu() {
        this.classApplied = false;
    }

    onNavClick(event: Event) {
        const target = event.target as HTMLElement;
        if (target.tagName === 'A' && target.hasAttribute('routerLink')) {
            this.classApplied = false;
        }
    }
}
